import * as ZapparThree from "@zappar/zappar-threejs";
import { PerspectiveCamera, Texture, WebGLRenderer, sRGBEncoding } from "three";
import { Scene } from "three";


export default class Renderer {
    public instance!: WebGLRenderer
    private isTracking: boolean;

    constructor() {
        //DAN/EMMA - Remove preserve drawing buffer here
        this.instance = new WebGLRenderer({ preserveDrawingBuffer: true })

        this.instance.outputEncoding = sRGBEncoding
        this.instance.physicallyCorrectLights = true;
        this.instance.shadowMap.enabled = true;

        this.isTracking = false;

        this.instance.setPixelRatio(window.devicePixelRatio);
        this.instance.setSize(window.innerWidth, window.innerHeight);

        this.resize()
    }

    public resize() {
        window.addEventListener("resize", () => {
            console.log('resize')
            this.instance.setPixelRatio(window.devicePixelRatio);
            this.instance.setSize(window.innerWidth, window.innerHeight);
        })
    }

    public update(scene: Scene, zapparCamera: ZapparThree.Camera, perspectiveCamera: PerspectiveCamera, texture: Texture) {
        if (this.isTracking) {
            this.instance.render(scene, zapparCamera);
        }
        else {
            this.instance.render(scene, perspectiveCamera);
        }
    }

    public toggleTracking(isTracking: boolean) {
        this.isTracking = isTracking;
    }

}
